<div class="default-workspaces-ch-panels">
  <!-- Apps -->
  <app-apps-panel-widget
    [company]="company"
    [apps]="company.apps"
    [isForDefault]="true"
    class="default-workspaces"
  ></app-apps-panel-widget>

  <!-- Resources-->

  <app-resources-panel-widget
    [company]="company"
    [resources]="company.resources"
    [isForDefault]="true"
    class="default-workspaces"
  ></app-resources-panel-widget>
</div>
